// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MDvt7","left":"styles_left__2YjeT","desktopActions":"styles_desktopActions__2ati8","title":"styles_title__3yAs9"};